import { ClaimFileUploadUseCase } from '../../../application';

export default class ClaimFileUploadService {
    constructor() {}

    async execute(event) {
        const request = await ClaimFileUploadUseCase(event);

        return request;
    }
}
